import type { ReactElement } from 'react';

import { useFlexiForwardSelector } from '@/App/tiles/FlexiForward/FlexiForwardContext.ts';
import { FlexiForwardFormField } from '@/App/tiles/FlexiForward/FlexiForwardTile/common/form/FlexiForwardFormField.tsx';
import { DatePickerWithTenorNext } from '@/components/ui/DatePickerWithTenorNext.tsx';
import { TradeCaptureValidationWrapper } from '@/components/ui/TradeCaptureFieldErrorWrapper.tsx';
import { useFlexiForwardPropertyChangedHandler } from '@/store/flexi-forward/hooks/useFlexiForwardPropertyChangedHandler.ts';
import type { TcValidation } from '@/store/types.ts';

export function StartDateField({ tileId, validation }: { tileId: string; validation?: TcValidation[] }): ReactElement {
  const { startDate, startDateTenor } = useFlexiForwardSelector((flexiForward) => ({
    startDate: flexiForward.properties.startDate,
    startDateTenor: flexiForward.properties.startDateTenor,
  }));

  const handleStartDateChanged = useFlexiForwardPropertyChangedHandler<string>(
    tileId,
    'Start date change',
    (dateStringOrTenor) => ({ startDate: dateStringOrTenor }),
  );

  return (
    <FlexiForwardFormField formattedMessageId="flexiForwardTile.mainFields.startDate.label">
      <TradeCaptureValidationWrapper validation={validation}>
        <DatePickerWithTenorNext date={startDate ?? ''} tenor={startDateTenor} onChange={handleStartDateChanged} />
      </TradeCaptureValidationWrapper>
    </FlexiForwardFormField>
  );
}
